<template>
  <section class="sli-sheet sli-sheet--lands">
    <header class="sli-sheet__head">
      فريق العمل
    </header>
    <p
      v-if="error"
      class="sli-cell__err"
      style="padding: 0 12px 8px;"
    >
      {{ error }}
    </p>
    <div
      v-for="(member, index) in members"
      :key="member._key || index"
      class="sli-grid sli-grid--fit sli-enc-row"
      style="padding: 8px 12px;"
    >
      <div class="sli-cell sli-cell--fit" style="--sli-fit-ch: 22;">
        <label class="sli-cell__label">الموظف</label>
        <v-select
          :value="member.employee_id"
          :options="employeeOptions"
          :reduce="val => val.id"
          :get-option-label="empLabel"
          :dir="'rtl'"
          :clearable="true"
          placeholder="اختر موظفاً"
          class="sli-mini-select"
          :disabled="disabled"
          @input="setEmployee(member, $event)"
          @search="onSearch"
        />
      </div>
      <sli-field
        v-model="member.role"
        label="الدور"
        :input-id="`team-role-${index}`"
        fit="12"
        :disabled="disabled"
      />
      <div class="sli-cell sli-cell--action">
        <label class="sli-radios">
          <input
            type="radio"
            :name="leadName"
            :checked="!!member.is_lead"
            :disabled="disabled"
            @change="setLead(index)"
          >
          قائد الفريق
        </label>
      </div>
      <div class="sli-cell sli-cell--action">
        <button
          v-if="!disabled && members.length > 1"
          type="button"
          class="sli-link-btn"
          @click="remove(index)"
        >
          حذف
        </button>
      </div>
    </div>
    <div
      v-if="!disabled"
      class="sli-add-wrap"
    >
      <button
        type="button"
        class="sli-add-btn"
        @click="add"
      >
        + إضافة عضو
      </button>
    </div>
  </section>
</template>

<script>
import vSelect from 'vue-select'
import SliField from './SliField.vue'
import { emptyTeamMember } from '../formModel'

export default {
  name: 'SliTeamFields',
  components: { vSelect, SliField },
  props: {
    value: { type: Array, default: () => [] },
    error: { type: String, default: '' },
    leadName: { type: String, default: 'sli-team-lead' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      extraEmployees: [],
      searchTimer: null,
    }
  },
  computed: {
    members() {
      return this.value && this.value.length ? this.value : []
    },
    storeEmployees() {
      const list = this.$store.getters['employees/employees']
      if (Array.isArray(list)) return list
      if (Array.isArray(list?.data)) return list.data
      return []
    },
    employeeOptions() {
      const map = {}
      this.storeEmployees.concat(this.extraEmployees).forEach(emp => {
        if (emp && emp.id != null) map[emp.id] = emp
      })
      this.members.forEach(row => {
        if (row.employee && row.employee.id) map[row.employee.id] = row.employee
      })
      return Object.values(map)
    },
  },
  created() {
    this.loadEmployees('')
  },
  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer)
  },
  methods: {
    empLabel(option) {
      if (!option) return ''
      return option.full_name || option.name || option.name_ar || `#${option.id}`
    },
    emit(next) {
      this.$emit('input', next)
    },
    add() {
      this.emit(this.members.concat([emptyTeamMember()]))
    },
    remove(index) {
      const next = this.members.slice()
      next.splice(index, 1)
      if (!next.some(row => row.is_lead) && next[0]) next[0].is_lead = true
      this.emit(next)
    },
    setLead(index) {
      const next = this.members.map((row, i) => ({ ...row, is_lead: i === index }))
      this.emit(next)
    },
    setEmployee(member, employeeId) {
      member.employee_id = employeeId
      const found = this.employeeOptions.find(e => e.id === employeeId)
      if (found) member.employee = found
      this.emit(this.members.slice())
    },
    onSearch(search, loading) {
      if (loading) loading(true)
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.loadEmployees(search).finally(() => {
          if (typeof loading === 'function') loading(false)
        })
      }, 300)
    },
    loadEmployees(search) {
      return this.$store.dispatch('employees/listEmployees', {
        query: { search: search || '', per_page: 30 },
      }).then(res => {
        const rows = Array.isArray(res) ? res : (res?.data || [])
        if (Array.isArray(rows)) this.extraEmployees = rows
      }).catch(() => {})
    },
  },
}
</script>
